import { render, staticRenderFns } from "./autoMatch.vue?vue&type=template&id=7dca39fe&scoped=true&"
import script from "./autoMatch.vue?vue&type=script&lang=js&"
export * from "./autoMatch.vue?vue&type=script&lang=js&"
import style0 from "./autoMatch.vue?vue&type=style&index=0&id=7dca39fe&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7dca39fe",
  null
  
)

export default component.exports